import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {CreateGameFormPropTypes} from "../utils/propTypes";

export default class BottomButtonBar extends Component {

    validateForm() {
        const form = this.props.form;
        return form.activePlayers.length && form.activeCourse;
    }

    render() {
        let startGameExtraClasses = 'bottom-button--disabled';
        let startGameOnClick = () => ({});

        if (this.validateForm()) {
            startGameOnClick = this.props.startGame;
            startGameExtraClasses = '';
        }

        let startGameButton = (<div
            onClick={() => startGameOnClick(this.props.form)}
            className={`bottom-button col-xs-8 ${startGameExtraClasses}`}
        >Start game</div>);

        if (this.props.disableStartingGame) {
            startGameButton = (<div
                className={`bottom-button col-xs-8 bottom-button--disabled`}
            >Start game</div>);
        }

        return (
            <div className="bottom-button-bar">
                <div onClick={this.props.goBack} className="bottom-button col-xs-4">BACK</div>
                {startGameButton}
            </div>
        );
    }
}

BottomButtonBar.propTypes = {
    form: CreateGameFormPropTypes,
    startGame: PropTypes.func.isRequired,
    disableStartingGame: PropTypes.bool.isRequired,
    goBack: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/BottomButtonBar.js